import { INFO } from 'constants/error-severities';

import {
  HIDE_CONFIRMATION_MODAL,
  SHOW_CONFIRMATION_MODAL,
  UPDATE_CONFIRMATION_MODAL_MESSAGE,
} from '../constants/actions';

const DEFAULT_CONFIRMATION_MODAL_STATE = {
  message: '',
  severity: INFO,
  show: false,
};

const confirmationModalReducer = (
  state = DEFAULT_CONFIRMATION_MODAL_STATE,
  action
) => {
  switch (action.type) {
    case HIDE_CONFIRMATION_MODAL:
      return { ...state, show: false };
    case SHOW_CONFIRMATION_MODAL:
      return {
        ...state,
        severity: action.severity,
        message: action.message,
        timerTimeout: action.timerTimeout,
        show: true,
      };
    case UPDATE_CONFIRMATION_MODAL_MESSAGE:
      return { ...state, message: action.message };
    default:
      return state;
  }
};

export default confirmationModalReducer;
